import './styles.scss'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'

const List = ({ setActiveTemplate, templateOptions, currentTemplate }) => {
  const { pathname } = useLocation()

  return (
    <ul className='templates-list'>
      {pathname !== '/dashboard/conversations/templates' && (
        <>
          <li className={currentTemplate === templateOptions.chatmail ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.chatmail)}>
            <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.chatmail}-icon.svg`)}`} width='44px' height='44px' alt='Chatmail' className='messenger' />
            ChatMail
          </li>
          {/* <li className={currentTemplate === templateOptions.chatweb ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.chatweb)}>
            <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.chatweb}-icon.svg`)}`} width='44px' height='44px' alt='chatweb' />
            {I18n.t('channels_chatweb')}
          </li> */}
        </>
      )}
      <li style={{ display:'flex' }} className={currentTemplate === templateOptions.whatsapp ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.whatsapp)}>
        <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.whatsapp}-icon.svg`)}`} width='44px' height='44px' alt='Whatsapp' className='messenger' />
        {I18n.t('channels_twilio_whatsapp')}
      </li>
      <li style={{ display:'flex' }} className={currentTemplate === templateOptions.whatsapp_whatsapp ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.whatsapp_whatsapp)}>
        <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.whatsapp}-icon.svg`)}`} width='44px' height='44px' alt='Whatsapp Cloud API' className='messenger' />
        {I18n.t('channels_whatsapp_whatsapp')}
      </li>
      {pathname !== '/dashboard/conversations/templates' && (
        <li className={currentTemplate === templateOptions.sms ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.sms)}>
          <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.sms}-icon.svg`)}`} width='44px' height='44px' alt='SMS' className='messenger' />
          {I18n.t('channels_sms')}
        </li>
      )}
      {pathname === '/dashboard/conversations/templates' && (
        <>
          <li className={currentTemplate === templateOptions.facebook ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.facebook)}>
            <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.facebook}-icon.svg`)}`} width='44px' height='44px' alt='Facebook Messenger' className='messenger' />
            {I18n.t('channels_messenger')}
          </li>
          <li className={currentTemplate === templateOptions.instagram ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.instagram)}>
            <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.instagram}-icon.svg`)}`} width='44px' height='44px' alt='Instagram Messenger' className='messenger' />
            {I18n.t('channels_instagram')}
          </li>
        </>
      )}
      {pathname !== '/dashboard/conversations/templates' && (
        <>
          <li className={currentTemplate === templateOptions.telegram ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.telegram)}>
            <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.telegram}-icon.svg`)}`} width='44px' height='44px' alt='Telegram' className='messenger' />
            {I18n.t('channels_telegram')}
          </li>
          <li className={currentTemplate === templateOptions.android ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.android)}>
            <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.android}-icon.svg`)}`} width='44px' height='44px' alt='android' className='messenger' />
            {I18n.t('channels_android')}
          </li>
          <li className={currentTemplate === templateOptions.ios ? 'active' : ''} onClick={() => setActiveTemplate(templateOptions.ios)}>
            <img src={`${getStaticImage(`/channels/orange-brand/${templateOptions.ios}-icon.svg`)}`} width='44px' height='44px' alt='ios' className='messenger' />
            {I18n.t('channels_wall_ios')}
          </li>
        </>
      )}
    </ul>
  )
}

export default List
